import { render, staticRenderFns } from "./ResearchOutputMinimal.vue?vue&type=template&id=9025d74e&scoped=true&"
import script from "./ResearchOutputMinimal.vue?vue&type=script&lang=js&"
export * from "./ResearchOutputMinimal.vue?vue&type=script&lang=js&"
import style0 from "./ResearchOutputMinimal.vue?vue&type=style&index=0&id=9025d74e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9025d74e",
  null
  
)

export default component.exports